import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, HostListener } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { SelectItem } from 'primeng/api';
import { eCampaignStatus, eCreativeTheme, eCreativeThemeName } from '@Workspace/_generated/enums';
import { ICreativeAssetDto, ICreativeDto, IDetailSocialCampaignJson, IEnumDataAttribute } from '@Workspace/_generated/interfaces';
import { IBaseCampaignDto } from '@Workspace/_generated/interfaces';
import { Functions } from '@Workspace/common';

@Component({
    selector: 'social-file-upload',
    templateUrl: './social-file-upload.component.html',
    styleUrls: ['./social-file-upload.component.scss']
})
export class SocialFileUploadComponent implements OnInit, OnDestroy {
    constructor(
    ) { }

     @Input() creative: ICreativeDto;
     @Input() reviewPage: boolean = false;
     @Input() isApprove: boolean = false;
     @Input() campaign: IBaseCampaignDto;
     @Input() creativeTypeDD: SelectItem[];
    @Output() openPreviewEvent: EventEmitter<any> = new EventEmitter();
     ngUnsubscribe = new Subject();
    creativeThemeDD: SelectItem[] = [];
    creativeThemeLabel: string;
    enumCampaignStatus = eCampaignStatus;
    isPreviewOpen: boolean;
    booleanTrue: boolean = true;
    booleanFalse: boolean = false;

    ngOnInit() {
        if (this.creative.detailSocialCampaignJson == null) {
            this.creative.detailSocialCampaignJson = {} as IDetailSocialCampaignJson;
            
        }
        
        this.creativeThemeLabel = Functions.getEnumName(eCreativeTheme, this.creative.detailSocialCampaignJson.creativeTheme);
        var creativeThemeDDFromMap = new Map<number, IEnumDataAttribute>([...eCreativeThemeName]);
        this.creativeThemeDD = this.enumMapToArray(creativeThemeDDFromMap);
        this.creativeThemeDD.unshift({ label: "-", value: 0 });

    }

    private enumMapToArray(map: Map<number, IEnumDataAttribute>): any[] {
        let result: any[] = [];
        let otherItem: any = null;

        map.forEach(((enumDataAttr, key) => {
            if (key!=0){
                const item = {
                    label: enumDataAttr.name,
                    value: key,
                    quantity: 0
                };

                if (enumDataAttr.name == "Other") {
                    otherItem = item;
                } else {
                    result.push(item);
                }
            }
        }
        ));

        result.sort((a, b) => a.label.localeCompare(b.label));

        if (otherItem) {
            result.push(otherItem);
        }
        return result;
    }


    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    setCreativeTheme(event) {
        this.creativeThemeLabel = Functions.getEnumName(eCreativeTheme, event.value);
        if (event.value !== eCreativeTheme.Other) {
            this.creative.detailSocialCampaignJson.otherCreativeThemeText = "";
        }
    }

    openPreview(event) {
        this.openPreviewEvent.emit(event);
        
    }

    showHideDialog(event: any) {
        this.isPreviewOpen = event.visible;
    }

    removeAsset(asset: ICreativeAssetDto) {
        let index = this.creative.creativeAssets.indexOf(asset);
        this.creative.creativeAssets.splice(index, 1);
    }

    get sponsorLogoAssetIndex(): number {
        const index = this.creative?.creativeAssets?.findIndex(asset => asset.descriptionJson?.position === 1) ?? -1;
        return index >= 0 ? index : 0;
    }

    onPostLocationChange(): void {
        if (!this.creative.detailSocialCampaignJson.postLocation?.includes('9')) {
            this.creative.detailSocialCampaignJson.otherPostLocation = "";
        }
    }

    get sponsorLogoRequired(): boolean {
        return this.creative?.detailSocialCampaignJson?.clientProvidedCreative === true;
    }

}
